module.exports = __webpack_public_path__ + "static/media/A3.de0ed190.jpg";